module.exports = __webpack_public_path__ + "static/media/1.3ac55b9d.jpg";